import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  FormControlLabel,
  Switch,
  Box,
  Typography
} from '@mui/material';
import AppDialog, { AppDialogTitle, AppDialogContent, AppDialogActions } from '../layout/AppDialog';

const CompanyModal = ({ open, onClose, onSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    email: '',
    phone: '',
    active: true,
    africastalking_username: '',
    africastalking_apikey: '',
    africastalking_sender_id: ''
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        address: initialData.address || '',
        email: initialData.email || '',
        phone: initialData.phone || '',
        active: initialData.active !== undefined ? initialData.active : true,
        africastalking_username: initialData.africastalking_username || '',
        africastalking_apikey: initialData.africastalking_apikey || '',
        africastalking_sender_id: initialData.africastalking_sender_id || ''
      });
    } else {
      // Reset form when creating new company
      setFormData({
        name: '',
        address: '',
        email: '',
        phone: '',
        active: true,
        africastalking_username: '',
        africastalking_apikey: '',
        africastalking_sender_id: ''
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSwitchChange = (e) => {
    setFormData(prev => ({
      ...prev,
      active: e.target.checked
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const validateForm = () => {
    return formData.name && formData.email && formData.phone;
  };

  return (
    <AppDialog open={open} onClose={onClose} maxWidth="md">
      <AppDialogTitle
        onClose={onClose}
        subtitle={initialData ? 'Update company settings and SMS configuration' : 'Add a new company to the platform'}
      >
        {initialData ? 'Edit Company' : 'Create New Company'}
      </AppDialogTitle>
      <form onSubmit={handleSubmit}>
        <AppDialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              required
              label="Company Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              error={!formData.name}
              helperText={!formData.name && "Company name is required"}
            />
            <TextField
              required
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              error={!formData.email}
              helperText={!formData.email && "Email is required"}
            />
            <TextField
              required
              label="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              fullWidth
              error={!formData.phone}
              helperText={!formData.phone && "Phone number is required"}
            />
            <TextField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              multiline
              rows={3}
              fullWidth
            />
            <Typography variant="h6" sx={{ mt: 2 }}>SMS Configuration (Africa's Talking)</Typography>
            <TextField
              label="Africa's Talking Username"
              name="africastalking_username"
              value={formData.africastalking_username}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Africa's Talking API Key"
              name="africastalking_apikey"
              type="password"
              value={formData.africastalking_apikey}
              onChange={handleChange}
              fullWidth
              helperText={initialData && initialData.africastalking_apikey ? "API Key is set. Enter a new key to change." : ""}
            />
            <TextField
              label="Africa's Talking Sender ID"
              name="africastalking_sender_id"
              value={formData.africastalking_sender_id}
              onChange={handleChange}
              fullWidth
            />
            {initialData && (
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.active}
                    onChange={handleSwitchChange}
                    name="active"
                    color="primary"
                  />
                }
                label={formData.active ? "Active" : "Inactive"}
              />
            )}
          </Box>
        </AppDialogContent>
        <AppDialogActions>
          <Button 
            onClick={onClose}
            variant="outlined"
            color="inherit"
          >
            Cancel
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
            disabled={!validateForm()}
          >
            {initialData ? 'Update' : 'Create'}
          </Button>
        </AppDialogActions>
      </form>
    </AppDialog>
  );
};

export default CompanyModal;
